//注意:token直接封装在方法里面 不需要再页面中当参数传
import store from "@/store";
let token = JSON.parse(window.localStorage.getItem("user"));
import request from "../utils/request.js"
import request2 from "../utils/request2.js"
import requestMock from "./mockRequist.js"
import {
    uploadFilesBaseUrl
} from "./baseURL";

function requestToken(url, params, methods) {
    // params.token = token;
    // let fd = new FormData();
    // for (const key in params) {
    //     if (params.hasOwnProperty(key)) {
    //         fd.append(key, params[key])
    //     }
    // }
    return request({
        url: url,
        method: methods,
        data: params,
    });
}

function mockRequest(url, params, methods) {
    return requestMock({
        url: url,
        method: methods,
        data: params,
    });
}

// 请求登录 API 的方法
function userLogin({
                       mobile,
                       code
                   }) {
    let fd = new FormData()
    fd.append("loginName", mobile)
    fd.append("pwd", code)
    return request({
        url: "/admin/login",
        method: "POST",
        data: fd
    });
}

export const userRegister = (params) => {
    return request({
        url: "/admin/user/info/insert",
        method: "POST",
        data: params
    });
}

// 三社联动-服务人员导出
export const sskldApi = {
    exportServiceItemsPerson(params) {
        return request2({
            url: "/admin/serviceItemsPerson/info/exportServiceItemsPerson",
            method: "POST",
            data: params,
            responseType: 'blob'
        });
    }
}
/****   党建 -     S  */


/****   党建 -     E  */
// 党建宣传
export const djxcApi = {
    getTableDataUrl: '/admin/partyPublicity/info/list',
    insert(params) {
        return requestToken('/admin/partyPublicity/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/partyPublicity/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/partyPublicity/info/deletePartyPublicity', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/partyPublicity/info/findPartyPublicityById', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/partyPublicity/info/list', params, 'POST')
    },
    // 党建宣传审核：
    audit(params) {
        return requestToken('/admin/partyPublicity/info/audit', params, 'POST')
    },
    // 按宣传数量统计
    findPartyPublicityStatistics(params) {
        return requestToken('/admin/partyPublicity/info/findPartyPublicityStatistics', params, 'POST')
    },
    // 按类别统计
    findPublicityWayStatistics(params) {
        return requestToken('/admin/partyPublicity/info/findPartyPublicityTypeStatistics', params, 'POST')
    },
    // 查看党建宣传关键字
    findPartyPublicityKeywords(params) {
        return requestToken('/admin/partyPublicity/info/findPartyPublicityKeywords', params, 'POST')
    },
}
// 党建-意见与建议
export const yjjyApi = {
    insert(params) {
        return requestToken('/admin/partyPublicity/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/partyPublicity/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/partyPublicity/info/deletePartyPublicity', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/complaintSuggestion/info/findComplaintSuggestionById', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/complaintSuggestion/info/findList', params, 'POST')
    },
    // 导出
    export (params) {
        return request2({
            url: "/admin/complaintSuggestion/info/export",
            method: "POST",
            data: params,
            responseType: 'blob'
        });
    },
    // 工作计划导出
    exportPlant (params) {
        return request2({
            url: "/admin/plant/info/exportPlant",
            method: "POST",
            data: params,
            responseType: 'blob'
        });
    },
    // 组织活动导出
    exportOrgLife(params) {
        return request2({
            url: "/admin/orgLife/info/exportOrgLife",
            method: "POST",
            data: params,
            responseType: 'blob'
        });
    },
    // 党员学习导出
    exportLearnResourceBase(params) {
        return request2({
            url: "/admin/learnResourceBase/info/exportLearnResourceBase",
            method: "POST",
            data: params,
            responseType: 'blob'
        });
    },
    // 志愿服务导出
    exportActivity(params) {
        return request2({
            url: "/admin/activity/info/exportActivity",
            method: "POST",
            data: params,
            responseType: 'blob'
        });
    },
    // 处理
    updateComplaintSuggestion(params) {
        return requestToken('/admin/complaintSuggestion/info/updateComplaintSuggestion', params, 'POST')
    },
    // 评价结果数据统计
    findSuggestionEvaluationStatistics(params) {
        return requestToken('/admin/complaintSuggestion/info/findSuggestionEvaluationStatistics', params, 'POST')
    },
    // 社区投诉与建议数据统计近5个月
    findSuggestionOrgStatistics(params) {
        return requestToken('/admin/complaintSuggestion/info/findSuggestionOrgStatistics', params, 'POST')
    },
    // 超时未处理
    findSuggestionOverTimeStatistics(params) {
        return requestToken('/admin/complaintSuggestion/info/findSuggestionOverTimeStatistics', params, 'POST')
    },

}

/****   智慧武装 -     S  */
// 国防新闻
export const gfxwApi = {
    getTableDataUrl: '/admin/defenseNews/info/list',
    insert(params) {
        return requestToken('/admin/defenseNews/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/defenseNews/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/defenseNews/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/defenseNews/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/defenseNews/info/list', params, 'POST')
    },
}
// 国防教育
export const gfjyApi = {
    getTableDataUrl: '/admin/defenseEducation/info/list',
    insert(params) {
        return requestToken('/admin/defenseEducation/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/defenseEducation/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/defenseEducation/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/defenseEducation/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/defenseEducation/info/list', params, 'POST')
    },
}
// 征兵宣传
export const zbxcApi = {
    getTableDataUrl: '/admin/defenseConscription/info/list',
    insert(params) {
        return requestToken('/admin/defenseConscription/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/defenseConscription/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/defenseConscription/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/defenseConscription/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/defenseConscription/info/list', params, 'POST')
    },
}
// 政策法规
export const zcfgApi = {
    getTableDataUrl: '/admin/defensePolicy/info/list',
    insert(params) {
        return requestToken('/admin/defensePolicy/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/defensePolicy/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/defensePolicy/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/defensePolicy/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/defensePolicy/info/list', params, 'POST')
    },
}
// 民兵训练
export const mbxlApi = {
    getTableDataUrl: '/admin/militiaTrain/info/list',
    insert(params) {
        return requestToken('/admin/militiaTrain/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/militiaTrain/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/militiaTrain/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/militiaTrain/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/militiaTrain/info/list', params, 'POST')
    },
}
// 社区登记
export const sqdjApi = {
    getTableDataUrl: '/admin/regCommunity/info/list',
    insert(params) {
        return requestToken('/admin/regCommunity/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/regCommunity/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/regCommunity/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/regCommunity/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/regCommunity/info/list', params, 'POST')
    },
}
// 常见问题
export const cjwtApi = {
    getTableDataUrl: '/admin/regProblem/info/list',
    insert(params) {
        return requestToken('/admin/regProblem/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/regProblem/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/regProblem/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/regProblem/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/regProblem/info/list', params, 'POST')
    },
}
// 报名流程
export const bmlcApi = {
    getTableDataUrl: '/admin/regProcess/info/list',
    insert(params) {
        return requestToken('/admin/regProcess/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/regProcess/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/regProcess/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/regProcess/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/regProcess/info/list', params, 'POST')
    },
}

/****   智慧武装 -     E  */

/****   数字妇联 -     S  */
//政策宣传
export const flpolicyApi = {
    getTableDataUrl: '/admin/policyAdvocacy/info/list',
    insert(params) {
        return requestToken('/admin/policyAdvocacy/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/policyAdvocacy/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/policyAdvocacy/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/policyAdvocacy/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/policyAdvocacy/info/list', params, 'POST')
    },
}
// 联系方式
export const wmdjContactApi = {
    getTableDataUrl: '/admin/womenContact/info/list',
    insert(params) {
        return requestToken('/admin/womenContact/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/womenContact/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/womenContact/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/womenContact/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/womenContact/info/list', params, 'POST')
    },
}
// 机构职能
export const wmdjFunctionApi = {
    getTableDataUrl: '/admin/organFunction/info/list',
    insert(params) {
        return requestToken('/admin/organFunction/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/organFunction/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/organFunction/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/organFunction/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/organFunction/info/list', params, 'POST')
    },
}
// 妇联领导
export const wmdjSexleaderApi = {
    getTableDataUrl: '/admin/womenLeader/info/list',
    insert(params) {
        return requestToken('/admin/womenLeader/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/womenLeader/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/womenLeader/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/womenLeader/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/womenLeader/info/list', params, 'POST')
    },
}

// 机构简介
export const wmdjMechanismApi = {
    getTableDataUrl: '/admin/organIntroduce/info/list',
    insert(params) {
        return requestToken('/admin/organIntroduce/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/organIntroduce/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/organIntroduce/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/organIntroduce/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/organIntroduce/info/list', params, 'POST')
    },
}
// 温馨港湾
export const wxdjApi = {
    getTableDataUrl: '/admin/cozyHarbor/info/list',
    insert(params) {
        return requestToken('/admin/cozyHarbor/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/cozyHarbor/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/cozyHarbor/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/cozyHarbor/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/cozyHarbor/info/list', params, 'POST')
    },
}
// 女性课堂
export const flClassApi = {
    getTableDataUrl: '/admin/womenKetang/info/list',
    insert(params) {
        return requestToken('/admin/womenKetang/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/womenKetang/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/womenKetang/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/womenKetang/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/womenKetang/info/list', params, 'POST')
    },
}
// 巧媳妇
export const flWifeApi = {
    getTableDataUrl: '/admin/cleverWife/info/list',
    insert(params) {
        return requestToken('/admin/cleverWife/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/cleverWife/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/cleverWife/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/cleverWife/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/cleverWife/info/list', params, 'POST')
    },
}
// 创业指导
export const loveGuidanceApi = {
    getTableDataUrl: '/admin/employGuide/info/list',
    insert(params) {
        return requestToken('/admin/employGuide/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/employGuide/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/employGuide/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/employGuide/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/employGuide/info/list', params, 'POST')
    },
}
// 就业技巧
export const loveSkillApi = {
    getTableDataUrl: '/admin/employTechnique/info/list',
    insert(params) {
        return requestToken('/admin/employTechnique/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/employTechnique/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/employTechnique/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/employTechnique/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/employTechnique/info/list', params, 'POST')
    },
}

// 岗位管理
export const lovePostManaApi = {
    getTableDataUrl: '/admin/postManage/info/list',
    insert(params) {
        return requestToken('/admin/postManage/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/postManage/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/postManage/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/postManage/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/postManage/info/list', params, 'POST')
    },
}

// 抗击肺炎
export const loveFightSickApi = {
    getTableDataUrl: '/admin/resistanceNcp/info/list',
    insert(params) {
        return requestToken('/admin/resistanceNcp/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/resistanceNcp/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/resistanceNcp/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/resistanceNcp/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/resistanceNcp/info/list', params, 'POST')
    },
}

// 公益招聘
export const loveRecruitApi = {
    getTableDataUrl: '/admin/welfareRecruit/info/list',
    insert(params) {
        return requestToken('/admin/welfareRecruit/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/welfareRecruit/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/welfareRecruit/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/welfareRecruit/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/welfareRecruit/info/list', params, 'POST')
    },
}

// 维权案例
export const helpCasesApi = {
    getTableDataUrl: '/admin/safeguardRights/info/list',
    insert(params) {
        return requestToken('/admin/safeguardRights/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/safeguardRights/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/safeguardRights/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/safeguardRights/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/safeguardRights/info/list', params, 'POST')
    },
}

// 家暴投诉
export const helpDVcomplaintApi = {
    getTableDataUrl: '/admin/violenceComplaint/info/list',
    insert(params) {
        return requestToken('/admin/violenceComplaint/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/violenceComplaint/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/violenceComplaint/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/violenceComplaint/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/violenceComplaint/info/list', params, 'POST')
    },
}

// 救助帮扶
export const helpHelpApi = {
    getTableDataUrl: '/admin/rescueHelp/info/list',
    insert(params) {
        return requestToken('/admin/rescueHelp/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/rescueHelp/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/rescueHelp/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/rescueHelp/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/rescueHelp/info/list', params, 'POST')
    },
}

// 法律援助
export const helpLawApi = {
    getTableDataUrl: '/admin/legalHelp/info/list',
    insert(params) {
        return requestToken('/admin/legalHelp/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/legalHelp/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/legalHelp/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/legalHelp/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/legalHelp/info/list', params, 'POST')
    },
}

/****   数字妇联     E  */




export const shVenueCenterApi = {
    getTableDataUrl: '/admin/venueCenter/info/list',
    insert(params) {
        return requestToken('/admin/venueCenter/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/venueCenter/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/venueCenter/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/venueCenter/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/venueCenter/info/list', params, 'POST')
    },
    // 发布 上架下架
    upWtzxInform(params) {
        return requestToken('/admin/stylistic/info/uplowStyCenter', params, 'POST')
    },
    // 审核
    auditWtzxInform(params) {
        return requestToken('/admin/stylistic/info/examineStylisticCenter', params, 'POST')
    },
}
// 场馆中心的查看列表
export const shVenueLookListApi = {
    getTableDataUrl: '/admin/shVenueLookList/info/list',
    insert(params) {
        return mockRequest('/admin/shVenueLookList/info/insert', params, 'POST')
    },
    updata(params) {
        return mockRequest('/admin/shVenueLookList/info/update', params, 'POST')
    },
    delete(params) {
        return mockRequest('/admin/shVenueLookList/info/delete', params, 'POST')
    },
    getDetail(params) {
        return mockRequest('/admin/shVenueLookList/info/get', params, 'POST')
    },
    getTableData(params) {
        return mockRequest('/admin/shVenueLookList/info/list', params, 'POST')
    },
}
/****   生活小站 - 场馆中心    E  */

/****   生活小站 - 业主之家    S  */
export const qpShOccupierApi = {
    getTableDataUrl: '/admin/businessFamily/info/list',
    insert(params) {
        return requestToken('/admin/businessFamily/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/businessFamily/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/businessFamily/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/businessFamily/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/businessFamily/info/list', params, 'POST')
    },
}
/****   生活小站 - 业主之家    E  */

/****   便民服务    S  */
export const qpHouseholdApi = {
    getTableDataUrl: '/admin/convenienceService/info/list',
    insert(params) {
        return requestToken('/admin/convenienceService/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/convenienceService/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/convenienceService/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/convenienceService/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/convenienceService/info/list', params, 'POST')
    },
}
/****   便民服务    E  */

/****   智慧农贸--- 商户信息    S  */
export const merchantInformationApi = {
    getTableDataUrl: '/admin/merchanInformation/info/list',
    insert(params) {
        return requestToken('/admin/merchanInformation/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/merchanInformation/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/merchanInformation/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/merchanInformation/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/merchanInformation/info/list', params, 'POST')
    },
}
/****   智慧农贸--- 商户信息    E  */

/****   智慧农贸--- 农产品信息    S  */
export const qpAgricultureProductsApi = {
    getTableDataUrl: '/admin/agriProduct/info/list',
    insert(params) {
        return requestToken('/admin/agriProduct/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/agriProduct/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/agriProduct/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/agriProduct/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/agriProduct/info/list', params, 'POST')
    },
    // 校验code唯一性
    getByCode(params) {
        return requestToken('/admin/agriProduct/info/getByCode', params, 'POST')
    },
    // 获取商铺信息
    getShopData(params) {
        return merchantInformationApi.getTableData({
            pageNo: 1,
            pageSize: 999
        })
    },
}
/****   智慧农贸--- 农产品信息    E  */
/****   智慧农贸--- 食品安全    S  */
export const qpFoodSafetyApi = {
    getTableDataUrl: '/admin/productSafe/info/list',
    insert(params) {
        return requestToken('/admin/productSafe/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/productSafe/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/productSafe/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/productSafe/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/productSafe/info/list', params, 'POST')
    },
    // 获取农产品信息
    getShopData(params) {
        return qpAgricultureProductsApi.getTableData({
            pageNo: 1,
            pageSize: 999
        })
    },
    // 校验code唯一性
    getByCode(params) {
        return qpAgricultureProductsApi.getByCode(params)
    },
}
/****   智慧农贸--- 食品安全    E  */



/****   矛盾调解--- 终止申请接口   S  */
export const terminateApplyApi = {
    getTableDataUrl: '/admin/terminateApply/info/list',
    insert(params) {
        return requestToken('/admin/registerMediation/info/terminateApply', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/terminateApply/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/terminateApply/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/terminateApply/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/terminateApply/info/list', params, 'POST')
    },
}
/****   矛盾调解--- 终止申请接口   E  */

/****   矛盾调解--- 调解协议接口   S  */
export const mediationProtocolApi = {
    getTableDataUrl: '/admin/mediationProtocol/info/list',
    insert(params) {
        return requestToken('/admin/registerMediation/info/mediationProtocol', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/mediationProtocol/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/mediationProtocol/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/mediationProtocol/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/mediationProtocol/info/list', params, 'POST')
    },
}
/****   矛盾调解--- 调解协议接口   E  */

/****   矛盾调解--- 口头协议接口   S  */
export const oralProtocolApi = {
    getTableDataUrl: '/admin/oralProtocol/info/list',
    insert(params) {
        return requestToken('/admin/registerMediation/info/oralProtocol', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/oralProtocol/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/oralProtocol/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/oralProtocol/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/oralProtocol/info/list', params, 'POST')
    },
}
/****   矛盾调解--- 口头协议接口   E  */

/****   矛盾调解--- 人民调解记录   S  */
export const peopleMediationRecordApi = {
    getTableDataUrl: '/admin/peopleMediationRecord/info/list',
    insert(params) {
        return requestToken('/admin/registerMediation/info/peopleMediationRecord', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/peopleMediationRecord/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/peopleMediationRecord/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/peopleMediationRecord/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/peopleMediationRecord/info/list', params, 'POST')
    },
}
/****   矛盾调解--- 人民调解记录   E  */

/****   矛盾调解--- 调解调查记录接口  S  */
export const mediationSurveyRecordApi = {
    getTableDataUrl: '/admin/mediationSurveyRecord/info/list',
    insert(params) {
        return requestToken('/admin/registerMediation/info/mediationSurveyRecord', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/mediationSurveyRecord/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/mediationSurveyRecord/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/mediationSurveyRecord/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/mediationSurveyRecord/info/list', params, 'POST')
    },
}
/****   矛盾调解--- 调解调查记录接口  E  */

/****   矛盾调解---立案调解接口   S  */
export const registerMediationApi = {
    getTableDataUrl: '/admin/registerMediation/info/list',
    // 导出
    createExcel(params) {
        return request2({
            url: "/admin/registerMediation/info/export",
            method: "POST",
            data: params,
            responseType: "blob"
        });
    },

    insert(params) {
        return requestToken('/admin/registerMediation/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/registerMediation/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/registerMediation/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/registerMediation/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/registerMediation/info/list', params, 'POST')
    },
    // 拒绝 受理,传 id,status:3,reason
    refuseApi(params) {
        return requestToken('/admin/conflictMediation/info/update', params, 'POST')
    },
    // 获取矛调详情
    getConflictMediationDetail(params) {
        return requestToken('/admin/conflictMediation/info/get', params, 'POST')
    },
    // 人民调解调查记录
    mediationSurveyRecordList(params) {
        return mediationSurveyRecordApi.getTableData(params)
    },
    // 人民调解记录
    peopleMediationRecordList(params) {
        return peopleMediationRecordApi.getTableData(params)
    },
    // 人民调解协议书
    mediationProtocolList(params) {
        return mediationProtocolApi.getTableData(params)
    },
    // 人民调解口头协议登记表
    oralProtocolList(params) {
        return oralProtocolApi.getTableData(params)
    },
    // 人民调解终止申请书
    terminateApplyList(params) {
        return terminateApplyApi.getTableData(params)
    },

}
/****   矛盾调解---立案调解接口   E  */

/****   矛盾调解--- 矛盾调解接口  S  */
export const conflictMediationApi = {
    getTableDataUrl: '/admin/conflictMediation/info/list',
    // 导出
    createExcel(params) {
        return request2({
            url: "/admin/conflictMediation/info/export",
            method: "POST",
            data: params,
            responseType: "blob"

        });
    },
    insert(params) {
        return requestToken('/admin/conflictMediation/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/conflictMediation/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/conflictMediation/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/conflictMediation/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/conflictMediation/info/list', params, 'POST')
    },
}
/****   矛盾调解--- 矛盾调解接口  E  */


/****   志愿者档案接口   S  */
export const volunteerArchiveApi = {
    getTableDataUrl: '/admin/volunteerArchive/info/list',
    insert(params) {
        return requestToken('/admin/volunteerArchive/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/volunteerArchive/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/volunteerArchive/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/volunteerArchive/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/volunteerArchive/info/list', params, 'POST')
    },
    // 一键归档
    archiveFile(params) {
        return requestToken('/admin/registerMediation/info/archiveFile', params, 'POST')
    },
}
/****   志愿者档案接口   E  */

/****   网格日志  S  */
export const gridLogApi = {
    insert(params) {
        return requestToken('/admin/gridLog/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/gridLog/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/gridLog/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/gridLog/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/gridLog/info/list', params, 'POST')
    },
    getTableData_community(params) {
        // 改成了list
        return requestToken('/admin/gridLog/info/findDistinctCommunity', {
                "pageNo": 1,
                "pageSize": 10,
                params
            },
            'POST')
    },
    getTableData_grid(params) {
        return requestToken('/admin/gridLog/info/findDistinctGrid', params, 'POST')
    },
    getTableData_user(params) {
        return requestToken('/admin/gridLog/info/findDistinctUser', params, 'POST')
    },
    getTableDataUrl: '/admin/gridLog/info/list',
    // 改成了list
    getTableDataUrl_community: '/admin/gridLog/info/findDistinctCommunity',
    getTableDataUrl_grid: '/admin/gridLog/info/findDistinctGrid',
    getTableDataUrl_user: '/admin/gridLog/info/findDistinctUser',
}
/****   网格日志  E  */

/****   获取网格员  S  */
export const getGridUserList = (params) => {
    return requestToken('/rbac/admin/user/info/list', params, 'POST')
}
/****   获取网格员  E  */


/****   青年服务  S  */

// 青年服务-青年教育
export const youthServiceEducationApi = {
    insert(params) {
        return requestToken('/admin/youthServiceEducation/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceEducation/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceEducation/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceEducation/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceEducation/info/list', params, 'POST')
    },
}
// 青年服务-青年课堂
export const youthServiceClassApi = {
    insert(params) {
        return requestToken('/admin/youthServiceClass/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceClass/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceClass/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceClass/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceClass/info/list', params, 'POST')
    },
}
// 青年服务-双创活动
export const youthServiceActivityApi = {
    insert(params) {
        return requestToken('/admin/youthServiceActivity/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceActivity/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceActivity/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceActivity/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceActivity/info/list', params, 'POST')
    },
    findRegistrationDetailById(params) {
        return requestToken('/admin/youthServiceActivity/info/findRegistrationDetailById', params, 'POST')
    },
}
// 青年服务-双创活动报名人员
export const youthServiceActivityApplicantApi = {
    insert(params) {
        return requestToken('/admin/youthServiceActivityApplicant/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceActivityApplicant/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceActivityApplicant/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceActivityApplicant/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceActivityApplicant/info/list', params, 'POST')
    },
    batchAduit(params) {
        return requestToken('/admin/youthServiceActivityApplicant/info/batchAduit', params, 'POST')
    },
}
// 青年服务-双创活动类型类型
export const youthServiceActivityTypeApi = {
    insert(params) {
        return requestToken('/admin/youthServiceActivityType/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceActivityType/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceActivityType/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceActivityType/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceActivityType/info/list', params, 'POST')
    },
}
// 青年服务-项目库
export const youthServiceProjectApi = {
    insert(params) {
        return requestToken('/admin/youthServiceProject/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceProject/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceProject/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceProject/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceProject/info/list', params, 'POST')
    },
}
// 青年服务-项目库关联人
export const youthServiceProjectPeopleApi = {
    insert(params) {
        return requestToken('/admin/youthServiceProjectPeople/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceProjectPeople/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceProjectPeople/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceProjectPeople/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceProjectPeople/info/list', params, 'POST')
    },
}
// 青年服务-感兴趣项目记录
export const youthServiceProjectLikeApi = {
    insert(params) {
        return requestToken('/admin/youthServiceProjectLike/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceProjectLike/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceProjectLike/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceProjectLike/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceProjectLike/info/list', params, 'POST')
    },
}

// 青年服务-加入我们基础信息
export const youthServiceEnterpriseApi = {
    insert(params) {
        return requestToken('/admin/youthServiceEnterprise/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceEnterprise/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceEnterprise/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceEnterprise/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceEnterprise/info/list', params, 'POST')
    },
}

// 青年服务-web
export const youthServeWebApi = {
    // 近期热门和活动档案库都是
    activitylistUrl: '/admin/youthServiceActivity/info/list',
    // 项目征集是
    insert(params) {
        return youthServiceProjectApi.insert(params)
    },
    // 项目库是
    prejectlist: '/admin/youthServiceProject/info/list',
    // 活动类型
    activeTypeArr(params) {
        return youthServiceActivityTypeApi.getTableData(params)
    },
    // 活动 - detail
    activitylist(params) {
        return requestToken('/admin/youthServiceActivity/info/list', params, 'POST')
    },
    // 活动 - detail
    activeDetail(params) {
        return requestToken('/admin/youthServiceActivity/info/get', params, 'POST')
    },
    // 项目库 - detail
    libryDetail(params) {
        return requestToken('/admin/youthServiceProject/info/get', params, 'POST')
    },
    // 项目库 - delete
    libryDelete(params) {
        return requestToken('/admin/youthServiceProject/info/delete', params, 'POST')
    },
    // 项目 - 对他感兴趣
    islike(params) {
        return requestToken('/admin/youthServiceProjectLike/info/insert', params, 'POST')
    },
    // 项目 - 取消 对他感兴趣
    deletelike(params) {
        return requestToken('/admin/youthServiceProjectLike/info/delete', params, 'POST')
    },
    // 青年课堂
    class(params) {
        return youthServiceClassApi.getTableData(params)
    },
    // 青年课堂 - detail
    classDetail(params) {
        return requestToken('/admin/youthServiceClass/info/get', params, 'POST')
    },

    // 青年教育
    education(params) {
        return youthServiceEducationApi.getTableData(params)
    },
    // 青年教育 - detail
    educationDetail(params) {
        return requestToken('/admin/youthServiceEducation/info/get', params, 'POST')
    },
    // 政策宣传 type:4
    policy(params) {
        return requestToken('/admin/livelihoodsMessage/info/list', params, 'POST')
    },
    // 政策宣传 详情
    policyDetail(params) {
        return requestToken('/admin/livelihoodsMessage/info/get', params, 'POST')
    },

}

export const weblikeProjectApi = {
    listurl: '/admin/youthServiceProjectLike/info/list',
    // 感兴趣的项目 type:4
    list(params) {
        return requestToken('/admin/youthServiceProjectLike/info/list', params, 'POST')
    },
    // 感兴趣的项目 详情
    detail(params) {
        return requestToken('/admin/youthServiceProjectLike/info/get', params, 'POST')
    },
}

// 青年服务-加入我们基础信息
export const webyouthServiceEnterpriseApi = {
    listurl: '/admin/youthServiceEnterprise/info/list',
    insert(params) {
        return requestToken('/admin/youthServiceEnterprise/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/youthServiceEnterprise/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/youthServiceEnterprise/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/youthServiceEnterprise/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/youthServiceEnterprise/info/list', params, 'POST')
    },
}


/****   青年服务  E  */

/****   民生服务 youthServiceindex  S  */
export const peopleServiceApi = {
    insert(params) {
        return requestToken('/admin/livelihoodsBase/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsBase/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/livelihoodsBase/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsBase/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/livelihoodsBase/info/list', params, 'POST')
    },
}
// 民生服务申请资料接口
export const livelihoodsApplyFileApi = {
    insert(params) {
        return requestToken('/admin/livelihoodsApplyFile/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsApplyFile/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/livelihoodsApplyFile/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsApplyFile/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/livelihoodsApplyFile/info/list', params, 'POST')
    },
}
// 民生服务问题库接口
export const LivelihoodsQuestionApi = {
    insert(params) {
        return requestToken('/admin/LivelihoodsQuestion/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/LivelihoodsQuestion/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/LivelihoodsQuestion/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/LivelihoodsQuestion/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/LivelihoodsQuestion/info/list', params, 'POST')
    },
}
// 民生服务中介服务接口
export const livelihoodsApplyMediumApi = {
    insert(params) {
        return requestToken('/admin/livelihoodsApplyMedium/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsApplyMedium/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/livelihoodsApplyMedium/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsApplyMedium/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/livelihoodsApplyMedium/info/list', params, 'POST')
    },
}
// 直播/政策宣传类型管理
export const livelihoodsTypesApi = {
    insert(params) {
        return requestToken('/admin/livelihoodsTypes/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsTypes/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/livelihoodsTypes/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsTypes/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/livelihoodsTypes/info/list', params, 'POST')
    },
    getTypeTree(params) {
        return requestToken('/admin/livelihoodsTypes/info/listTree', params, 'POST')
    },
}
//获取组织机构信息
export const getFindOrg = (params) => {
    return requestToken('/admin/org/info/findOrg', params, 'POST')
}


// 服务指南/政策宣传
// type(integer, optional): 类型1服务指南2卫生健康服务 - 政策宣传3社医保服务 - 政策宣传 4 青年服务 - 政策宣传
export const livelihoodsMessageApi = {
    insert(params) {
        return requestToken('/admin/livelihoodsMessage/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsMessage/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/livelihoodsMessage/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsMessage/info/get', params, 'POST')
    },
    getDetailUrl: '/admin/livelihoodsMessage/info/get',
    getTableDataUrl: '/admin/livelihoodsMessage/info/list',
    getTableData(params) {
        return requestToken('/admin/livelihoodsMessage/info/list', params, 'POST')
    },
}

// 名声服务-直播
export const livelihoodsLiveStreamApi = {
    insert(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('admin/livelihoodsLiveStream/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/get', params, 'POST')
    },
    getTableDataUrl: '/admin/livelihoodsLiveStream/info/list',
    getTableData(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/list', params, 'POST')
    },
}
// 巡查进度1
export const xcApi = {
    insert(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('admin/livelihoodsLiveStream/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/get', params, 'POST')
    },
    getTableDataUrl: '/admin/inspectionRecord/info/findInspectionRecordList',
    getTableData(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/list', params, 'POST')
    },
}

export const xcApi2 = {
    insert(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('admin/livelihoodsLiveStream/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/get', params, 'POST')
    },
    getTableDataUrl: '/admin/inspectionRecord/info/findRecordList',
    getTableData(params) {
        return requestToken('/admin/livelihoodsLiveStream/info/list', params, 'POST')
    },
}

/****   民生服务  E  */
/****   纠纷类型管理接口  S  */
export const issueTypeApi = {
    insert(params) {
        return requestToken('/admin/issueType/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/issueType/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/issueType/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/issueType/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/issueType/info/list', params, 'POST')
    },

    getSelectdata(params) {
        return requestToken('/admin/issueType/info/listOption', params, 'POST')
    },

}
export const issueTypelistUrl = '/admin/businessOrg/info/list';
/****   纠纷类型管理接口  E  */

/****   物业企业管理接口   S  */
export const houseEnterpriseApi = {
    getTableDataUrl: '/admin/houseEnterprise/info/list',
    insert(params) {
        return requestToken('/admin/houseEnterprise/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/houseEnterprise/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/houseEnterprise/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/houseEnterprise/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/houseEnterprise/info/list', params, 'POST')
    },
    getSelectData(params) {
        return requestToken('/admin/houseEnterprise/info/listOption', params, 'POST')
    },
    // 服务小区的select数据
    getSelectArea(params) {
        return requestToken('/admin/smallArea/info/listOption', params, 'POST')
    },
}

export const houseEnterpriselistUrl = '/admin/businessOrg/info/list';
export const houseEnterpriseGetSelectData = (params) => {
    return houseEnterpriseApi.getSelectData(params)
}
export const houseEnterprisedetail = (params) => {
    return houseEnterpriseApi.getDetail(params)
}
/****   物业企业管理接口   E  */

/****   业委会管理接口   S  */
export const businessOrgApi = {
    getTableDataUrl: '/admin/businessOrg/info/list',
    insert(params) {
        return requestToken('/admin/businessOrg/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/businessOrg/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/businessOrg/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/businessOrg/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/businessOrg/info/list', params, 'POST')
    },
}
export const businessOrgADetail = (params) => {
    return businessOrgApi.getDetail(params)
}
/****   业委会管理接口   E  */

/****   问题与建议接口   S  */
export const problemSuggestionApi = {
    insert(params) {
        return requestToken('/admin/problemSuggestion/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/problemSuggestion/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/problemSuggestion/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/problemSuggestion/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/problemSuggestion/info/list', params, 'POST')
    },
    frontList(params) {
        return requestToken('/admin/problemSuggestion/info/frontList', params, 'POST')
    },
    evaluation(params) {
        return requestToken('/admin/problemSuggestion/info/evaluation', params, 'POST')
    },
}

export const problemSuggestionFrontList = (params) => {
    return requestToken('/admin/problemSuggestion/info/frontList', params, 'POST')
}
export const problemSuggestionDetail = (params) => {
    return problemSuggestionApi.getDetail(params)
}
export const problemSuggestionevaluation = (params) => {
    return problemSuggestionApi.evaluation(params)
}

/****   问题与建议接口   E  */



/****   纠纷处理接口    S  */
export const issueApi = {
    insert(params) {
        return requestToken('/admin/issue/info/insert', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/issue/info/update', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/issue/info/delete', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/issue/info/get', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/issue/info/list', params, 'POST')
    },
    evaluation(params) {
        return requestToken('/admin/issue/info/evaluation', params, 'POST')
    },
}


/****   纠纷处理接口    E  */




export const uploadUrlApi = request.defaults.baseURL + "/admin/consul/info/uplodfiles";


//调用党员接口
function findPartyMemberArchives({
    name,
    education,
    partyAge,
    payStates,
    sex,
    nation,
    maritalStatus,
    partyTime,
    representativeMember,
    partyWorkCode,
    partyBranchCode,
    partyGroupCode,
    pageNo,
    pageSize
}) {
let fd = new FormData()
fd.append("pageNo", pageNo)
fd.append("pageSize", pageSize)
fd.append("name", name)
fd.append("education", education)
fd.append("partyAge", partyAge)
fd.append("payStates", payStates)
fd.append("sex", sex)
fd.append("nation", nation)
fd.append("maritalStatus", maritalStatus)
fd.append("partyTime", partyTime)
fd.append("representativeMember", representativeMember)
fd.append("partyWorkCode", partyWorkCode)
fd.append("partyBranchCode", partyBranchCode)
fd.append("partyGroupCode", partyGroupCode)
fd.append("token", token)
return request({
url: "/djyl/admin/partyMemberArchives/info/findPartyMemberArchives",
method: "POST",
data: fd
});
}
//导出表格
function downloadPartyExcel({
                                name,
                                education,
                                partyAge,
                                payStates,
                                sex,
                                nation,
                                maritalStatus,
                                partyTime,
                                representativeMember,
                                partyWorkCode,
                                partyBranchCode,
                                partyGroupCode
                            }) {
    let fd = new FormData()
    fd.append("name", name)
    fd.append("education", education)
    fd.append("partyAge", partyAge)
    fd.append("payStates", payStates)
    fd.append("sex", sex)
    fd.append("nation", nation)
    fd.append("maritalStatus", maritalStatus)
    fd.append("partyTime", partyTime)
    fd.append("representativeMember", representativeMember)
    fd.append("partyWorkCode", partyWorkCode)
    fd.append("partyBranchCode", partyBranchCode)
    fd.append("partyGroupCode", partyGroupCode)
    fd.append("token", token)
    return request2({
        url: "/ypt/admin/partyMemberArchives/info/downloadPartyExcel",
        method: "POST",
        data: fd,
        responseType: 'blob'
    });
}

//调用党员投票新增
function insertPartyVote(formLabelAlign) {
    let arr = JSON.stringify(formLabelAlign).toString()
    let fd = new FormData()
    fd.append("token", token)
    fd.append("formLabelAlign", arr)
    return request({
        url: "/admin/partyVote/info/insertPartyVote",
        method: "POST",
        data: fd
    });
}
//调用党员投票修改
function updatePartyVote(formLabelAlign) {
    let arr = JSON.stringify(formLabelAlign).toString()
    let fd = new FormData()
    fd.append("token", token)
    fd.append("formLabelAlign", arr)
    return request({
        url: "/admin/partyVote/info/updatePartyVote",
        method: "POST",
        data: fd
    });
}
//调用党员投票审核
function auditPartyVote(formLabelAlign) {
    let arr = JSON.stringify(formLabelAlign).toString()
    let fd = new FormData()
    fd.append("token", token)
    fd.append("formLabelAlign", arr)
    return request({
        url: "/admin/partyVote/info/auditPartyVote",
        method: "POST",
        data: fd
    });
}
//判断是否是新增过的党员投票名称
function findActivityName(activityName) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("activityName", activityName)
    return request({
        url: "/admin/partyVote/info/findActivityName",
        method: "POST",
        data: fd
    });
}
//查看党员投票的总信息
function findPartyVote({
                           pageNo,
                           pageSize,
                           activityName,
                           auditStatus,
                           activityStatus,
                           activityType,
                           voteTime,
                           joinNumber,
                           visitsNumber,
                           name,
                           pooto
                       }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    fd.append("activityName", activityName)
    fd.append("auditStatus", auditStatus)
    fd.append("activityStatus", activityStatus)
    fd.append("activityType", activityType)
    fd.append("voteTime", voteTime)
    fd.append("joinNumber", joinNumber)
    fd.append("visitsNumber", visitsNumber)
    fd.append("name", name)
    fd.append("pooto", pooto)
    return request({
        url: "/admin/partyVote/info/findPartyVote",
        method: "POST",
        data: fd
    });
}
//按照id查看党员投票详情信息
function findPartyVoteById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/partyVote/info/findPartyVoteById",
        method: "POST",
        data: fd
    });
}
//按照字段查看党员投票详情信息
function findPartyVotelist({
                               activityName,
                               createDate,
                               voteTime,
                               pageNo,
                               pageSize
                           }) {
    let fd = new FormData()
    fd.append("token", token)
    if (activityName != "") {
        fd.append("activityName", activityName)
    }
    if (createDate != "") {
        fd.append("createDate", createDate)
    }
    if (voteTime != "") {
        fd.append("voteTime", voteTime)
    }
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    return request({
        url: "/admin/partyVote/info/findPartyVote",
        method: "POST",
        data: fd
    });
}
//按照id删除党员投票信息
function deletePartyVote(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/partyVote/info/deletePartyVote",
        method: "POST",
        data: fd
    });
}
//党员一线报道新增
function insertPartyOrganization({
                                     title,
                                     photo,
                                     content,
                                     displayOrder,
                                     displayTime
                                 }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("organizationType", 4)
    fd.append("title", title)
    fd.append("photo", photo)
    fd.append("content", content)
    fd.append("displayOrder", displayOrder)
    fd.append("displayTimes", displayTime)
    return request({
        url: "/djyl/admin/partyOrganization/info/insertPartyOrganization",
        method: "POST",
        data: fd
    });
}
//查看一线报道总信息
function findPartyOrganization({
                                   pageNo,
                                   pageSize
                               }) {
    let fd = new FormData()
    fd.append("organizationType", 4)
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    return request({
        url: "/admin/partyOrganization/info/findPartyOrganization",
        method: "POST",
        data: fd
    });
}
//查看一线报道按照id查询
function findPartyOrganizationById(id) {
    let fd = new FormData()
    fd.append("organizationType", 4)
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/partyOrganization/info/findPartyOrganizationById",
        method: "POST",
        data: fd
    });
}
//一线报道按照id编辑
function updatePartyOrganization(some) {
    let fd = new FormData()
    fd.append("organizationType", 4)
    fd.append("token", token)
    fd.append("id", some.id)
    fd.append("title", some.title)
    fd.append("photo", some.photo)
    fd.append("content", some.content)
    fd.append("displayOrder", some.displayOrder)
    fd.append("displayTimes", some.displayTimes)
    return request({
        url: "/admin/partyOrganization/info/updatePartyOrganization",
        method: "POST",
        data: fd
    });
}
//党员一线报道按照id审核
function auditPartyOrganization({
                                    id,
                                    auditStatus,
                                    auditOpinion
                                }) {
    let fd = new FormData()
    fd.append("organizationType", 4)
    fd.append("token", token)
    fd.append("partyOrganizationId", id)
    fd.append("auditStatus", auditStatus)
    fd.append("auditOpinion", auditOpinion)
    return request({
        url: "/admin/partyOrganization/info/auditPartyOrganization",
        method: "POST",
        data: fd
    });
}
//按照id删除党员投票信息
function deletePartyOrganization(id) {
    let fd = new FormData()
    fd.append("organizationType", 4)
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/partyOrganization/info/deletePartyOrganization",
        method: "POST",
        data: fd
    });
}
//按照字段查看一线报道列表信息
function findPartyOrganizationbysome({
                                         title,
                                         createDate,
                                         displayTime,
                                         pageNo,
                                         pageSize
                                     }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("organizationType", 4)
    if (title != "") {
        fd.append("title", title)
    }
    if (createDate != "") {
        fd.append("createDate", createDate)
    }
    if (displayTime != "") {
        fd.append("displayTime", displayTime)
    }
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    return request({
        url: "/admin/partyOrganization/info/findPartyOrganization",
        method: "POST",
        data: fd
    });
}



//在线学习道新增
function zaixianxuexiinsertPartyOrganization({
                                                 title,
                                                 photo,
                                                 content,
                                                 displayOrder,
                                                 displayTime
                                             }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("organizationType", 5)
    fd.append("title", title)
    fd.append("photo", photo)
    fd.append("content", content)
    fd.append("displayOrder", displayOrder)
    fd.append("displayTimes", displayTime)
    return request({
        url: "/djyl/admin/partyOrganization/info/insertPartyOrganization",
        method: "POST",
        data: fd
    });
}
//在线学习总信息
function zaixianxuexifindPartyOrganization({
                                               pageNo,
                                               pageSize
                                           }) {
    let fd = new FormData()
    fd.append("organizationType", 5)
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    return request({
        url: "/admin/partyOrganization/info/findPartyOrganization",
        method: "POST",
        data: fd
    });
}
//在线学习按照id查询
function zaixianxuexifindPartyOrganizationById(id) {
    let fd = new FormData()
    fd.append("organizationType", 5)
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/partyOrganization/info/findPartyOrganizationById",
        method: "POST",
        data: fd
    });
}
//在线学习按照id编辑
function zaixianxuexiupdatePartyOrganization(some) {
    let fd = new FormData()
    fd.append("organizationType", 5)
    fd.append("token", token)
    fd.append("id", some.id)
    fd.append("title", some.title)
    fd.append("photo", some.photo)
    fd.append("content", some.content)
    fd.append("displayOrder", some.displayOrder)
    fd.append("displayTimes", some.displayTimes)
    return request({
        url: "/admin/partyOrganization/info/updatePartyOrganization",
        method: "POST",
        data: fd
    });
}
//在线学习按照id审核
function zaixianxuexiauditPartyOrganization({
                                                id,
                                                auditStatus,
                                                auditOpinion
                                            }) {
    let fd = new FormData()
    fd.append("organizationType", 5)
    fd.append("token", token)
    fd.append("partyOrganizationId", id)
    fd.append("auditStatus", auditStatus)
    fd.append("auditOpinion", auditOpinion)
    return request({
        url: "/admin/partyOrganization/info/auditPartyOrganization",
        method: "POST",
        data: fd
    });
}
//按照id删除在线学习
function zaixianxuexideletePartyOrganization(id) {
    let fd = new FormData()
    fd.append("organizationType", 5)
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/partyOrganization/info/deletePartyOrganization",
        method: "POST",
        data: fd
    });
}
//按照字段查看在线学习列表信息
function zaixianxuexifindPartyOrganizationbysome({
                                                     title,
                                                     createDate,
                                                     displayTime,
                                                     pageNo,
                                                     pageSize
                                                 }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("organizationType", 5)
    if (title != "") {
        fd.append("title", title)
    }
    if (createDate != "") {
        fd.append("createDate", createDate)
    }
    if (displayTime != "") {
        fd.append("displayTime", displayTime)
    }
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    return request({
        url: "/admin/partyOrganization/info/findPartyOrganization",
        method: "POST",
        data: fd
    });
}

//党员档案新增图片上传
function uploadPartyVote(file) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append('file', file)
    return request({
        url: "/ypt/controller/uploadVotePic/info/uploadPartyVote",
        method: "POST",
        data: fd
    });
}
// 党员档案投票选项新增图片上传
function uploadVote(file) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append('file', file)
    return request({
        url: "/controller/uploadVotePic/info/uploadVote",
        method: "POST",
        data: fd
    });
}
//党员档案新增
function insertPartyMemberArchives(addjbxx) {
    let params = JSON.stringify(addjbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/djyl/admin/partyMemberArchives/info/insertPartyMemberArchives",
        method: "POST",
        data: fd
    });
}
//党员档案查看
function findPartyMemberArchivesById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/djyl/admin/partyMemberArchives/info/findPartyMemberArchivesById",
        method: "POST",
        data: fd
    });
}
//党员档案编辑
function updatePartyMemberArchives(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/djyl/admin/partyMemberArchives/info/updatePartyMemberArchives",
        method: "POST",
        data: fd
    });
}
//党员档案编辑
function deletePartyMemberArchives(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/djyl/admin/partyMemberArchives/info/deletePartyMemberArchives",
        method: "POST",
        data: fd
    });
}
//党员省地址查询
function findAddressByParentId({
                                   id
                               }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/djyl/admin/address/info/findAddressByParentId",
        method: "POST",
        data: fd
    });
}
//党组织树形查询
function findPartyOrgBuildTreelist(data) {
    // let fd = new FormData()
    // fd.append("token", token)
    return request({
        url: "/djyl/admin/partyOrgBuild/info/findPartyOrgBuildTreelist",
        method: "POST",
        data: data
    });
}
//党员类型统计
function fingPartyTypeStatistics({
    name,
    education,
    partyAge,
    payStates,
    sex,
    nation,
    maritalStatus,
    partyTime,
    representativeMember,
    partyWorkCode,
    partyBranchCode,
    partyGroupCode
}) {
let fd = new FormData()
fd.append("name", name)
fd.append("education", education)
fd.append("partyAge", partyAge)
fd.append("payStates", payStates)
fd.append("sex", sex)
fd.append("nation", nation)
fd.append("maritalStatus", maritalStatus)
fd.append("partyTime", partyTime)
fd.append("representativeMember", representativeMember)
fd.append("partyWorkCode", partyWorkCode)
fd.append("partyBranchCode", partyBranchCode)
fd.append("partyGroupCode", partyGroupCode)
fd.append("token", token)
return request({
url: "/djyl/admin/partyMemberArchives/info/fingPartyTypeStatistics",
method: "POST",
data: fd
});
}
//党员结构统计
function findPartyStructureStatistics({
    name,
    education,
    partyAge,
    payStates,
    sex,
    nation,
    maritalStatus,
    partyTime,
    representativeMember,
    partyWorkCode,
    partyBranchCode,
    partyGroupCode
}) {
let fd = new FormData()
fd.append("name", name)
fd.append("education", education)
fd.append("partyAge", partyAge)
fd.append("payStates", payStates)
fd.append("sex", sex)
fd.append("nation", nation)
fd.append("maritalStatus", maritalStatus)
fd.append("partyTime", partyTime)
fd.append("representativeMember", representativeMember)
fd.append("partyWorkCode", partyWorkCode)
fd.append("partyBranchCode", partyBranchCode)
fd.append("partyGroupCode", partyGroupCode)
fd.append("token", token)
return request({
url: "/djyl/admin/partyMemberArchives/info/findPartyStructureStatistics",
method: "POST",
data: fd
});
}
//党员缴费统计
function fingPartyPayStatistics({
                                    name,
                                    education,
                                    partyAge,
                                    payStates,
                                    sex,
                                    nation,
                                    maritalStatus,
                                    partyTime,
                                    representativeMember,
                                    partyWorkCode,
                                    partyBranchCode,
                                    partyGroupCode
                                }) {
    let fd = new FormData()
    fd.append("name", name)
    fd.append("education", education)
    fd.append("partyAge", partyAge)
    fd.append("payStates", payStates)
    fd.append("sex", sex)
    fd.append("nation", nation)
    fd.append("maritalStatus", maritalStatus)
    fd.append("partyTime", partyTime)
    fd.append("representativeMember", representativeMember)
    fd.append("partyWorkCode", partyWorkCode)
    fd.append("partyBranchCode", partyBranchCode)
    fd.append("partyGroupCode", partyGroupCode)
    fd.append("token", token)
    return request({
        url: "/ypt/admin/partyMemberArchives/info/fingPartyPayStatistics",
        method: "POST",
        data: fd
    });
}
//党员缴费基本信息
function findPartyPayRecordById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/djyl/admin/partyPayRecord/info/findPartyPayRecordById",
        method: "POST",
        data: fd
    });
}
//党员缴费记录列表
function findPartyPayRecord({
                                id,
                                pageNo,
                                pageSize
                            }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    return request({
        url: "/djyl/admin/partyPayRecord/info/findPartyPayRecord",
        method: "POST",
        data: fd
    });
}
//新增党员缴费记录
function insertPartyPayRecord({
                                  partyMemberArchiveId,
                                  payProject,
                                  payCost,
                                  payType,
                                  payTime,
                                  payTimes,
                                  remarks
                              }, ) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("partyMemberArchiveId", partyMemberArchiveId)
    fd.append("payProject", payProject)
    fd.append("payCost", payCost)
    fd.append("payType", payType)
    fd.append("payTime", payTime)
    fd.append("payTimes", payTimes)
    fd.append("remarks", remarks)
    return request({
        url: "/djyl/admin/partyPayRecord/info/insertPartyPayRecord",
        method: "POST",
        data: fd
    });
}
//机构树形查询
function OrgTreeForUserlist(data) {
    return request({
        url: "/rbac/admin/org/info/OrgTreeForUserlist",
        method: "POST",
        data: data
    });
}

// 退出登录
function Loginout({
                      token
                  }) {
                    //   console.log(token);
    return request({
        url: "/rbac/admin/logout",
        method: "POST",
        params: {
            token
        }
    });
}


//退休党员新增
function insertPartyMemberArchivestx(addjbxx) {
    let params = JSON.stringify(addjbxx);
    let fd = new FormData()
    // fd.append("token", token)
    // fd.append("params", params)
    return request({
        url: "/admin/retiredParty/info/insertPartyMemberArchives",
        method: "POST",
        data: {
            "token": token,
            "params": params
        }
    });
}
//退休党员列表查询
function findPartyMemberArchivestx({
                                       pageNo,
                                       pageSize,
                                       name,
                                       partyAge,
                                       phone,
                                       hobby,
                                       partyBranchCode,
                                       partyWorkCode,
                                       partyGroupCode
                                   }) {
    let fd = new FormData()
    // fd.append("pageNo", pageNo)
    // fd.append("pageSize", pageSize)
    // fd.append("token", token)
    // fd.append("name", name)
    // fd.append("partyAge", partyAge)
    // fd.append("phone", phone)
    // fd.append("hobby", hobby)
    // fd.append("partyBranchCode", partyBranchCode)
    // fd.append("partyWorkCode", partyWorkCode)
    // fd.append("partyGroupCode", partyGroupCode)
    return request({
        url: "/admin/retiredParty/info/findPartyMemberArchives",
        method: "POST",
        data: {
            "pageNo": pageNo,
            "pageSize": pageSize,
            "token": token,
            "name": name,
            "partyAge": partyAge,
            "phone": phone,
            "hobby": hobby,
            "partyBranchCode": partyBranchCode,
            "partyWorkCode": partyWorkCode,
            "partyGroupCode": partyGroupCode
        }
    });
}


//退休党员查看详情
function findPartyMemberArchivesByIdtx(id) {
    let fd = new FormData()
    // fd.append("token", token)
    // fd.append("id", id)
    return request({
        url: "/admin/retiredParty/info/findPartyMemberArchivesById",
        method: "POST",
        data: {
            "token": token,
            "id": id
        }
    });
}


//退休党员编辑
function updatePartyMemberArchivestx(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    // fd.append("token", token)
    // fd.append("params", params)
    return request({
        url: "/admin/retiredParty/info/updatePartyMemberArchives",
        method: "POST",
        data: {
            "token": token,
            "params": params
        }
    });
}

//退休党员爱好统计
function findHobbyStatistics({
                                 partyBranchCode,
                                 partyWorkCode,
                                 partyGroupCode
                             }) {
    let fd = new FormData()
    // fd.append("token", token)
    // fd.append("partyBranchCode", partyBranchCode)
    // fd.append("partyWorkCode", partyWorkCode)
    // fd.append("partyGroupCode", partyGroupCode)

    return request({
        url: "/admin/retiredParty/info/findHobbyStatistics",
        method: "POST",
        data: {
            "token": token,
            "partyBranchCode": partyBranchCode,
            "partyWorkCode": partyWorkCode,
            "partyGroupCode": partyGroupCode
        }
    });
}
// 组织活动 上传
function uploadPartyPhoto(file) {
    let fd = new FormData()
    // fd.append("token", token)
    fd.append('file', file)
    // console.log(file);
    return request({
        url: "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
        method: "POST",
        data: fd,
        baseURL: uploadFilesBaseUrl

    });
}
//退休党员单位统计
function findWorkNatureStatistics({
                                      partyBranchCode,
                                      partyWorkCode,
                                      partyGroupCode
                                  }) {
    let fd = new FormData()
    // fd.append("token", token)
    // fd.append("partyBranchCode", partyBranchCode)
    // fd.append("partyWorkCode", partyWorkCode)
    // fd.append("partyGroupCode", partyGroupCode)
    return request({
        url: "/admin/retiredParty/info/findWorkNatureStatistics",
        method: "POST",
        data: {
            "token": token,
            "partyBranchCode": partyBranchCode,
            "partyWorkCode": partyWorkCode,
            "partyGroupCode": partyGroupCode
        }
    });
}
//退休党员年龄统计
function findAgeStatistics({
                               partyBranchCode,
                               partyWorkCode,
                               partyGroupCode
                           }) {
    let fd = new FormData()
    // fd.append("token", token)
    // fd.append("partyBranchCode", partyBranchCode)
    // fd.append("partyWorkCode", partyWorkCode)
    // fd.append("partyGroupCode", partyGroupCode)
    return request({
        url: "/admin/retiredParty/info/findAgeStatistics",
        method: "POST",
        data: {
            "token": token,
            "partyBranchCode": partyBranchCode,
            "partyWorkCode": partyWorkCode,
            "partyGroupCode": partyGroupCode
        }
    });
}
//查看APP账号的总信息
function findAppUser({
                         pageNo,
                         pageSize,
                         name,
                         phone,
                         states
                     }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    fd.append("name", name)
    fd.append("phone", phone)
    fd.append("states", states)
    return request({
        url: "/admin/appUser/info/findAppUser",
        method: "POST",
        data: fd
    });
}
//调用APP账号新增
function insertAppUser(params) {
    console.log('8888');
    console.log(params);
    // let arr = JSON.stringify(params)
    // let fd = new FormData()
    // fd.append("token", token)
    // fd.append("params", arr)
    // console.log(params);
    // console.log(fd);
    return request({
        url: "/admin/appUser/info/insertAppUser",
        method: "POST",
        data: params
    });
}
// APP账号查看详情
function findAppUserById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/appUser/info/findAppUserById",
        method: "POST",
        data: fd
    });
}
// APP账号修改
function updateAppUser(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/admin/appUser/info/updateAppUser",
        method: "POST",
        data: fd
    });
}
// APP账号删除
function deleteAppUser(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/appUser/info/deleteAppUser",
        method: "POST",
        data: fd
    });
}
//查看组织机构的总信息
// function findPartyOrgBuild(data) {
//     // let fd = new FormData()
//     // fd.append("token", token)
//     // fd.append("pageNo", pageNo)
//     // fd.append("pageSize", pageSize)
//     // fd.append("states", states)
//     // fd.append("orgName", orgName)
//     return request({
//         url: "/admin/partyOrgBuild/info/findPartyOrgBuild",
//         method: "POST",
//         data: data
//     });
// }
//调用组织机构新增
function insertPartyOrgBuild(params) {
    let arr = JSON.stringify(params)
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/admin/partyOrgBuild/info/insertPartyOrgBuild",
        method: "POST",
        data: params
    });
}
// 组织机构查看详情
function findPartyOrgBuildById(id) {
    return request({
        url: "/admin/partyOrgBuild/info/findPartyOrgBuildById",
        method: "POST",
        data: {
            id
        }
    });
}
// 组织机构修改
function updatePartyOrgBuild(edijbxx) {
    return request({
        url: "/admin/partyOrgBuild/info/updatePartyOrgBuild",
        method: "POST",
        data: edijbxx
    })
}

// 组织机构删除
function deletePartyOrgBuild(id) {
    return request({
        url: "/admin/partyOrgBuild/info/deletePartyOrgBuild",
        method: "POST",
        data: {
            id
        }
    });
}
//查看短信记录的总信息
function findSms({
                     pageNo,
                     pageSize,
                     category,
                     content
                 }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    fd.append("category", category)
    fd.append("content", content)
    return request({
        url: "/admin/sms/info/findSms",
        method: "POST",
        data: fd
    });
}
//调用短信记录新增
function insertSms(params) {
    let arr = JSON.stringify(params)
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/admin/sms/info/insertSms",
        method: "POST",
        data: fd
    });
}
// 短信记录查看详情
function findSmsById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/sms/info/findSmsById",
        method: "POST",
        data: fd
    })
}
// 专家库新增图片上传
function uploadExpertBankPhoto(file) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append('file', file)
    return request({
        url: "/controller/uploadVotePic/info/uploadExpertBankPhoto",
        method: "POST",
        data: fd
    });
}
//查看专家库的总信息
function findExpertBank({
                            pageNo,
                            pageSize,
                            name,
                            auditStatus
                        }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    if (name != "") {
        fd.append("name", name)
    }
    if (auditStatus != "") {
        fd.append("auditStatus", auditStatus)
    }
    return request({
        url: "/admin/expertBank/info/findExpertBank",
        method: "POST",
        data: fd
    });
}
//调用专家库新增
function insertExpertBank(params) {
    let arr = JSON.stringify(params)
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/admin/expertBank/info/insertExpertBank",
        method: "POST",
        data: fd
    });
}
// 专家库查看详情
function findExpertBankById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/expertBank/info/findExpertBankById",
        method: "POST",
        data: fd
    });
}
// 专家库修改
function updateExpertBank(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/admin/expertBank/info/updateExpertBank",
        method: "POST",
        data: fd
    })
}
// 专家库审核
function auditExpertBank(params) {
    let arr = JSON.stringify(params).toString()
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/admin/expertBank/info/auditExpertBank",
        method: "POST",
        data: fd
    });
}
// 专家库删除
function deleteExpertBank(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/expertBank/info/deleteExpertBank",
        method: "POST",
        data: fd
    });
}
//查看系统设置的总信息
function findSystemSetup({
                             pageNo,
                             pageSize,
                             name,
                             type
                         }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    if (name != "") {
        fd.append("name", name)
    }
    if (type != "") {
        fd.append("type", type)
    }
    return request({
        url: "/admin/systemSetup/info/findSystemSetup",
        method: "POST",
        data: fd
    });
}
//调用系统设置新增
function insertSystemSetup(params) {
    let arr = JSON.stringify(params)
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/admin/systemSetup/info/insertSystemSetup",
        method: "POST",
        data: fd
    });
}
// 系统设置查看详情
function findSystemSetupById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/systemSetup/info/findSystemSetupById",
        method: "POST",
        data: fd
    });
}
// 系统设置修改
function updateSystemSetup(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/admin/systemSetup/info/updateSystemSetup",
        method: "POST",
        data: fd
    })
}
// 系统设置审核
function auditSystemSetup(params) {
    let arr = JSON.stringify(params).toString()
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/admin/systemSetup/info/auditSystemSetup",
        method: "POST",
        data: fd
    });
}
// 系统设置删除
function deleteSystemSetup(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/systemSetup/info/deleteSystemSetup",
        method: "POST",
        data: fd
    });
}
// 学习教育新增图片上传
function uploadLearnTeach1(file) {
    let fd = new FormData()
    // fd.append("token", token)
    fd.append('file', file)
    return request({
        url: "/controller/uploadVotePic/info/uploadLearnTeach",
        method: "POST",
        data: fd
    });
}
//查看学习教育的总信息
function findLearnTeach({
                            pageNo,
                            pageSize,
                            name,
                            auditStatus,
                            firstType,
                            secondType,
                            createDate
                        }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    if (name != "") {
        fd.append("name", name)
    }
    if (auditStatus != "") {
        fd.append("auditStatus", auditStatus)
    }
    if (firstType != "") {
        fd.append("firstType", firstType)
    }
    if (secondType != "") {
        fd.append("secondType", secondType)
    }
    if (createDate != "") {
        fd.append("createDate", createDate)
    }
    return request({
        url: "/admin/learnTeach/info/findLearnTeach",
        method: "POST",
        data: fd
    });
}
//调用学习教育新增
function insertLearnTeach(params) {
    let arr = JSON.stringify(params)
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/admin/learnTeach/info/insertLearnTeach",
        method: "POST",
        data: fd
    });
}
// 学习教育查看详情
function findLearnTeachById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/learnTeach/info/findLearnTeachById",
        method: "POST",
        data: fd
    });
}
// 学习教育修改
function updateLearnTeach(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/admin/learnTeach/info/updateLearnTeach",
        method: "POST",
        data: fd
    });
}
// 学习教育删除
function deleteLearnTeach(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/learnTeach/info/deleteLearnTeach",
        method: "POST",
        data: fd
    });
}
// 查看机构管理的总信息
function findOrg({
                     pageNo,
                     pageSize,
                     orgName,
                     orgType
                 }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    if (orgName != "") {
        fd.append("orgName", orgName)
    }
    if (orgType != "") {
        fd.append("orgType", orgType)
    }
    return request({
        url: "/org/info/findOrg",
        method: "POST",
        data: fd
    });
}
// 调用机构管理新增
function insertOrg(params) {
    let arr = JSON.stringify(params)
    console.log('000');
    console.log(params);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    console.log(fd.getAll("params"));
    return request({
        url: "/org/info/insertOrg",
        method: "POST",
        data: fd
    });
}
// 机构管理修改
function updateOrg(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/org/info/updateOrg",
        method: "POST",
        data: fd
    });
}
// 机构管理查看详情
function findOrgById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/org/info/findOrgById",
        method: "POST",
        data: fd
    });
}
// 机构管理删除
function deleteOrg(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/org/info/deleteOrg",
        method: "POST",
        data: fd
    });
}
// 查看岗位管理的总信息
function list({
                  pageNo,
                  pageSize,
                  postName,
                  isValid
              }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    if (postName != "") {
        fd.append("postName", postName)
    }
    if (isValid != "") {
        fd.append("isValid", isValid)
    }
    return request({
        url: "/sys/post/list",
        method: "POST",
        data: fd
    });
}
// 调用岗位管理新增
function insert(params) {
    let arr = JSON.stringify(params)
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", arr)
    return request({
        url: "/sys/post/insert",
        method: "POST",
        data: fd
    });
}
// 岗位管理修改
function update(edijbxx) {
    let params = JSON.stringify(edijbxx);
    let fd = new FormData()
    fd.append("token", token)
    fd.append("params", params)
    return request({
        url: "/sys/post/update",
        method: "POST",
        data: fd
    });
}
// 岗位管理查看详情
function findPostById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/sys/post/findPostById",
        method: "POST",
        data: fd
    });
}
// 岗位管理删除
function deletePsot(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/sys/post/delete",
        method: "POST",
        data: fd
    });
}
// 查看权限管理的总信息
function menuList({
                      pageNo,
                      pageSize,
                      name,
                      isShow
                  }) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("pageNo", pageNo)
    fd.append("pageSize", pageSize)
    if (name != "") {
        fd.append("name", name)
    }
    if (isShow != "") {
        fd.append("isShow", isShow)
    }
    // params.append("token", token)
    return request({
        url: "/admin/menu/info/list",
        method: "POST",
        data: fd
    });
}
// 权限管理上级菜单树形查询
function findMenuTree() {
    let fd = new FormData()
    fd.append("token", token)
    return request({
        url: "/rbac/admin/menu/info/getTree",
        method: "POST",
        data: fd
    });
}
// 调用权限管理新增
function insertMenu(params) {
    let token = token
    // params.token = token
    return request({
        url: "/rbac/admin/menu/info/insert",
        method: "POST",
        data: {
            params,
            token
        }
    });
}
// 权限管理修改
function updateMenu(params) {
    return request({
        url: "/rbac/admin/menu/info/update",
        method: "POST",
        data: params
    });
}
// 权限管理查看详情
function findMenuById(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/rbac/admin/menu/info/findById",
        method: "POST",
        data: fd
    });
}
// 岗位管理删除
function deleteMenu(id) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("id", id)
    return request({
        url: "/admin/menu/info/delete",
        method: "POST",
        data: fd
    });
}
// 查看会议直播的总信息
function findLiveMeeting(params) {
    return request({
        url: "/admin/liveMeeting/info/list",
        method: "POST",
        data: params
    });
}
// 调用会议直播新增
function insertLiveMeeting(params) {
    return request({
        url: "/admin/liveMeeting/info/insert",
        method: "POST",
        data: params
    });
}
// 会议直播查看详情
function findLiveMeetingById(id) {
    return request({
        url: "/admin/liveMeeting/info/findById",
        method: "POST",
        data: id
    });
}
// 会议直播修改
function updateLiveMeeting(edijbxx) {
    return request({
        url: "/admin/liveMeeting/info/update",
        method: "POST",
        data: edijbxx
    });
}
// 会议直播删除
function deleteLiveMeeting(id) {
    return request({
        url: "/admin/liveMeeting/info/delete",
        method: "POST",
        data: id
    });
}
// 会议规模图表
function MeetingChartsOne(params) {
    return request({
        url: "/admin/liveMeeting/info/findMeetingPersonStatistics",
        method: "POST",
        data: params
    });
}
// 会议时长图表
function MeetingChartsTwo(params) {
    return request({
        url: "/admin/liveMeeting/info/findMeetingHoursStatistics",
        method: "POST",
        data: params
    });
}
// 会议性质图表
function MeetingChartsThree(params) {
    return request({
        url: "/admin/liveMeeting/info/findMeetingTypeStatistics",
        method: "POST",
        data: params
    });
}
// 会议直播 按钮
function startLive(id) {
    return request({
        url: "/admin/liveMeeting/info/startLive",
        method: "POST",
        data: id
    });
}
//党员档案手机号验证
function findPartyPhone(phone) {
    let fd = new FormData()
    fd.append("token", token)
    fd.append("phone", phone)
    return request({
        url: "/djyl/admin/partyMemberArchives/info/findPartyPhone",
        method: "POST",
        data: fd
    });
}
//党员档案身份证号验证
function findPartyIdNumber(val) {
    let fd = new FormData()
    // fd.append("token", token)
    // fd.append("idNumber", val)
    return request({
        url: "/djyl/admin/partyMemberArchives/info/findPartyIdNumber",
        method: "POST",
        data: {
            "token": token,
            "idNumber": val
        }
    });
}

//服务社区 投诉建议 导出表格
function downloadComplaints(data) {
    return request2({
        url: "/admin/complaints/info/downloadComplaints",
        method: "POST",
        data: data,
        responseType: 'blob'
    });
}

//服务社区 团队发展 导出表格
function downloadTeam(data) {
    return request2({
        url: "/admin/team/info/downloadTeam",
        method: "POST",
        data: data,
        responseType: 'blob'
    });
}

//服务社区 团队发展 导出表格
function downloadTeamPerson(data) {
    return request2({
        url: "/admin/team/info/downloadTeamPerson",
        method: "POST",
        data: data,
        responseType: 'blob'
    });
}
//服务社区 商品管理 导出表格
function downloadGoods(data) {
    return request2({
        url: "/admin/goods/info/downloadGoods",
        method: "POST",
        data: data,
        responseType: 'blob'
    });
}
//服务社区 兑换列表 导出表格
function downloadExchange(data) {
    return request2({
        url: "/admin/exchange/info/downloadExchange",
        method: "POST",
        data: data,
        responseType: 'blob'
    });
}
//服务社区 意见与征集 导出表格 downloadOpinionPerson
function downloadOpinionPerson(data) {
    return request2({
        url: "/admin/opinionCollection/info/downloadOpinionPerson",
        method: "POST",
        data: data,
        responseType: 'blob'
    });
}
//服务社区 积分管理 导出表格 downloadOpinionPerson
function downloadPersonIntegral(data) {
    return request2({
        url: "/admin/personIntegral/info/downloadPersonIntegral",
        method: "POST",
        data: data,
        responseType: 'blob'
    });
}

/*** 社区服务 组织机构   S  */

function OrganGettabData(params) {
    return requestToken('/admin/partySocBuild/info/list', params, 'POST')
}
// 组织分布 新增
function OrganInsert(params) {
    return requestToken('/admin/partySocBuild/info/insert', params, 'POST')
}
//组织分布 修改
function OrganUpdate(params) {
    return requestToken('/admin/partySocBuild/info/update', params, 'POST')
}
//组织分布 详情
function OrganGetDetail(ids) {
    return requestToken('/admin/partySocBuild/info/get', {
        id: ids
    }, 'POST')
}
//组织分布 删除
function OrganGetDelete(ids) {
    return requestToken('/admin/partySocBuild/info/delete', {
        id: ids
    }, 'POST')
}

//组织生活 详情
function OrganActivityInsert(params) {
    return requestToken('/admin/partySocActivity/info/insert', params, 'POST')
}

function OrganActivitylist(params) {
    return requestToken('/admin/partySocActivity/info/list', params, 'POST')
}

function OrganActivityupdate(params) {
    return requestToken('/admin/partySocActivity/info/update', params, 'POST')
}

function OrganActivityDelete(ids) {
    return requestToken('/admin/partySocActivity/info/delete', ids, 'POST')
}

function OrganActivityfindRegistrationDetail(ids) {
    return requestToken('/admin/partySocActivity/info/findRegistrationDetailById', ids, 'POST')
}

/*** 社区服务 组织机构   E  */
/*** 网格工作 - 议题协商相关   S  */
/** 人员类别  S**/
const consulTypePersionApi = {
    insert(params) {
        return requestToken('/admin/consultPersonType/info/insertConsultPersonType', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/admin/partySocActivity/info/insert', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/consultPersonType/info/deleteConsultPersonType', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/consultPersonType/info/findConsultPersonTypeById', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/consultPersonType/info/findConsultPersonTypeList', params, 'POST')
    },

    // 获取条件查询的一级分类
    getTypeData(params) {
        return requestToken('/admin/consultPersonType/info/findConsultPersonType', params, 'POST')
    },
    // 获取类别树状图
    getTypTreeeData(params) {
        return requestToken('/admin/consultPersonType/info/findConsultPersonTypetree', params, 'POST')
    },
}

export const getTypeById_p = (params) => {
    return consulTypePersionApi.getTableData(params)
}

/** 人员类别  E**/
export const getConsulTYpePersion = (params) => {
    return requestToken('/admin/consulType/info/findConsultPersonList', params, 'POST')
}
//获取条件查询的议题分类
export const getConsulType = (params) => {
    return requestToken('/admin/consulType/info/findConsultType', params, 'POST')
}
//二级分类查询
export const getCfindConsultTypeList = (params) => {
    return requestToken('/admin/consulType/info/findConsultTypeList', params, 'POST')
}
// export const uploadUrl =
/** 议题协商  S**/
export const consulApi = {
    insert(params) {
        return requestToken('/admin/recreationalActivity/info/listRecreationalActivity', params, 'POST')
    },
    updata(params) {
        return requestToken('/admin/consul/info/updateConsult', params, 'POST')
    },
    delete(params) {
        return requestToken('/admin/consul/info/deleteConsult', params, 'POST')
    },
    getDetail(params) {
        return requestToken('/admin/consul/info/findConsultById', params, 'POST')
    },
    getTableData(params) {
        return requestToken('/admin/consul/info/findConsultList', params, 'POST')
    },

    delay(params) {
        return requestToken('/admin/consul/info/delayConsult', params, 'POST')
    },
    updateResults(params) {
        return requestToken('/admin/consul/info/updateResults', params, 'POST')
    },
    findConsultAddress(params) {
        return requestToken('/admin/consulAddress/info/findConsultAddressList', params, 'POST')
    },
    // 图表加载函数
    consultStatistics(params) {
        return requestToken('/admin/consul/info/consultStatistics', params, 'POST')
    },
    listOrg(params) {
        return requestToken('/admin/consul/info/listOrg', params, 'POST')
    },

}
/** 议题协商  E**/
// export default {
//     consulApiDetail: consulApi.getDetail,
//     consulApiUpdateResults: consulApi.updateResults,
// };
export const consulApiFindUserByOrgIds = (params) => {
    return requestToken('/admin/user/info/findUserByOrgIds', params, 'POST')
}

export const consulApiUpdateResults = (params) => {
    return consulApi.updateResults(params)
}
export const getConsulListOrg = (params) => {
    return consulApi.listOrg(params)
}
//议题协商- 审批
export const consulApprovalConsult = (params) => {
    return requestToken('/admin/consul/info/approvalConsult', params, 'POST')
}


export const consulApiDetail = (params) => {
    return consulApi.getDetail(params)
}

export const consulApiDelay = (params) => {
    return consulApi.delay(params)
}

export const getConsulPersonTree = (params) => {
    return consulTypePersionApi.getTypTreeeData(params)
}

/*** 网格工作 - 议题协商相关   E  */


export {
    consulTypePersionApi,
    OrganActivityfindRegistrationDetail,
    OrganActivityInsert,
    OrganActivitylist,
    OrganActivityupdate,
    OrganActivityDelete,
    OrganGettabData,
    OrganInsert,
    OrganUpdate,
    OrganGetDetail,
    OrganGetDelete,
    deleteLiveMeeting,
    updateLiveMeeting,
    findLiveMeetingById,
    insertLiveMeeting,
    findLiveMeeting,
    MeetingChartsOne,
    deleteMenu,
    findMenuById,
    updateMenu,
    insertMenu,
    menuList,
    findMenuTree,
    deletePsot,
    update,
    findPostById,
    insert,
    list,
    deleteOrg,
    findOrgById,
    updateOrg,
    insertOrg,
    findOrg,
    deleteLearnTeach,
    updateLearnTeach,
    findLearnTeachById,
    insertLearnTeach,
    uploadLearnTeach1,
    findLearnTeach,
    deleteSystemSetup,
    auditSystemSetup,
    updateSystemSetup,
    findSystemSetupById,
    insertSystemSetup,
    findSystemSetup,
    uploadExpertBankPhoto,
    auditExpertBank,
    updateExpertBank,
    insertExpertBank,
    findExpertBankById,
    findExpertBank,
    deleteExpertBank,
    findSmsById,
    insertSms,
    findSms,
    deletePartyOrgBuild,
    updatePartyOrgBuild,
    findPartyOrgBuildById,
    insertPartyOrgBuild,
    deleteAppUser,
    updateAppUser,
    findAppUserById,
    insertAppUser,
    findAppUser,
    findAgeStatistics,
    findWorkNatureStatistics,
    findHobbyStatistics,
    userLogin,
    Loginout,
    findPartyMemberArchives,
    findPartyMemberArchivestx,
    insertPartyVote,
    findActivityName,
    auditPartyVote,
    uploadPartyVote,
    uploadVote,
    findPartyVote,
    findPartyVoteById,
    updatePartyVote,
    deletePartyVote,
    findPartyVotelist,
    insertPartyOrganization,
    findPartyOrganization,
    findPartyOrganizationById,
    updatePartyOrganization,
    auditPartyOrganization,
    deletePartyOrganization,
    findPartyOrganizationbysome,
    zaixianxuexiinsertPartyOrganization,
    zaixianxuexifindPartyOrganization,
    zaixianxuexifindPartyOrganizationById,
    zaixianxuexiupdatePartyOrganization,
    zaixianxuexiauditPartyOrganization,
    zaixianxuexideletePartyOrganization,
    zaixianxuexifindPartyOrganizationbysome,
    uploadPartyPhoto,
    insertPartyMemberArchives,
    findPartyMemberArchivesById,
    findPartyMemberArchivesByIdtx,
    updatePartyMemberArchives,
    updatePartyMemberArchivestx,
    deletePartyMemberArchives,
    findAddressByParentId,
    findPartyOrgBuildTreelist,
    fingPartyTypeStatistics,
    findPartyStructureStatistics,
    fingPartyPayStatistics,
    OrgTreeForUserlist,
    findPartyPayRecordById,
    findPartyPayRecord,
    insertPartyPayRecord,
    insertPartyMemberArchivestx,
    findPartyPhone,
    findPartyIdNumber,
    downloadPartyExcel,
    downloadComplaints, //服务社区 投诉建议 导出表格
    downloadTeam, //服务社区 团队发展 导出表格
    downloadTeamPerson, //服务社区 团队人员 导出表格
    downloadGoods, //服务社区 商品管理 导出表格
    downloadExchange, //服务社区 兑换列表 导出表格
    downloadOpinionPerson, //服务社区 意见与征集 导出表格
    downloadPersonIntegral, //服务社区 积分管理 导出表格
    MeetingChartsTwo,
    MeetingChartsThree,
    startLive
};

//   async gettablelist() {
//           this.loading = true;
//           let formData = new FormData();
//           // formData.append("pageNo", this.pageConfig.pageNo);
//           // formData.append("pageSize", this.pageConfig.pageSize);
//           formData.append("belongAddressId", this.belongAddressId);
//           let result = await metaDataMgrDao.getAllHealthData(formData);
//           console.log(result);
//           if (result.code != 200) {
//             this.loading = false;
//             return;
//           }
//           let data = result.content.list;
//           // 获取用户数据
//           this.tabledata = data;
//           // // 总条数
//           this.pageConfig.total = result.content.count;
//           this.loading = false;
//           // 强制重渲染页面
//           // this.$forceUpdate()
//
